/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Info_ErrorInputs */

const es_tools_legajox_info_error = /** @type {(inputs: Tools_Legajox_Info_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener información de Legajox`)
};

const en_tools_legajox_info_error = /** @type {(inputs: Tools_Legajox_Info_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error getting Legajox info`)
};

/**
* | output |
* | --- |
* | "Error getting Legajox info" |
*
* @param {Tools_Legajox_Info_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_info_error = /** @type {((inputs?: Tools_Legajox_Info_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Info_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_info_error(inputs)
	return en_tools_legajox_info_error(inputs)
});
export { tools_legajox_info_error as "tools.legajox.info_error" }